<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <div class="dialog-title">
        <h2>!!!</h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
            style="position:absolute; top:0; right:0;">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="w-100">
        <div class="d-flex flex-row p-2">
            <div class="d-flex flex-column justify-content-between w-100 p-2">
                {{ messagesService.getMessage() }}
                <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2">
                    <button mat-flat-button color="warn" mat-dialog-close class="w-b">Zamknij</button>
                </mat-dialog-actions>

            </div>
        </div>

    </mat-dialog-content>
</div>